export default "__VITE_ASSET__26acb244__"